import { render } from "./FacetsComponent.vue?vue&type=template&id=20dae55b&ts=true"
import script from "./FacetsComponent.vue?vue&type=script&lang=ts"
export * from "./FacetsComponent.vue?vue&type=script&lang=ts"

import "./FacetsComponent.vue?vue&type=style&index=0&id=20dae55b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__